/**
 * list装载
 * @param _this
 * @param entity
 * @param pathType
 */
function listMounted(_this) {
    //设置filter
    _this.$store.commit(_this.entity + "/setFilterAttribute", {
        key: "workflowQueryTypeFilter",
        newValue: _this.pathType
    })
    //设置filterHolder，让清空查询条件也清除不掉workflowQueryTypeFilter这个条件
    _this.$store.commit(_this.entity + "/setFilterHolder", {"workflowQueryTypeFilter": _this.pathType})
    //如果pathType是list，就清空查询条件和结果
    if (_this.pathType === "list") {
        _this.$store.dispatch("base/MMFClearFilter", _this.entity)
    }
    //如果是todo或wait，就自动执行查询
    else if (_this.pathType === "todo" || _this.pathType === "wait") {
        _this.$store.dispatch("base/MMFLoadRows", _this.entity)
    }
}

/**
 * list处理task
 * @param _this
 * @param entity
 * @param path：跳转的路径，如果为空就默认跳转到entityTask.vue
 * @param businessData
 */
function listHandleApprove(_this, businessData, path) {

    //判断如果允许修改，并且设置有自定义的modifyFormName，
    if (businessData.statusAllowModify && businessData.statusModifyEntity) {
        //就把modifyFormName（首字母大写）拼装上entity组成新的store.modelName
        // var vuexModelName = _this.entity + businessData.statusModifyEntity.charAt(0).toUpperCase() + businessData.statusModifyEntity.slice(1);

        //设置vuex中modifyForm的entity和processBusinessData（深拷贝）
        _this.$store.commit(businessData.statusModifyEntity + "/setEntity", businessData)
        _this.$store.commit(businessData.statusModifyEntity + "/setProcessBusinessData", JSON.parse(JSON.stringify(businessData)))
    }

    //设置vuex中entity的entity和processBusinessData（深拷贝）
    //因为emWorkflowBusinessDataEditor中显示和修改可能用的是两个vuex模块中的内容，所以都要修改
    _this.$store.commit(_this.entity + "/setEntity", businessData)
    _this.$store.commit(_this.entity + "/setProcessBusinessData", JSON.parse(JSON.stringify(businessData)))

    //path不为空，就按path跳转
    if (path) {
        _this.$router.push({path, query: {pathType: _this.pathType}});
    } else {
        //否则就按name=entityTask跳转
        _this.$router.push({name: _this.entity + 'Task', query: {pathType: _this.pathType}});
    }
}

/**
 * task页面装载
 * @param _this
 */
function taskMounted(_this) {
    _this.taskPathType = _this.$route.query.pathType
}

/**
 * task页面，判断是否为编辑
 * @param _this
 * @returns {boolean}
 */
function taskIsEdit(_this, businessData) {
    //如果是待办,并且当前任务状态允许修改，就返回true
    if (_this.$route.query.pathType && _this.$route.query.pathType === "todo" && businessData.statusAllowModify) {
        return true;
    }
    return false;
}

/**
 * 获取modifyFormName
 * @param _this
 * @returns {boolean}
 */
function getModifyFormName(businessData) {
    //如果是待办,并且当前任务状态允许修改，就返回true
    if (businessData.statusAllowModify && businessData.statusModifyEntity) {
        return businessData.statusModifyEntity;
    }
    return "";
}

/**
 * task页面完成任务后
 * @param _this
 */
function taskHandleTaskCompleted(_this) {
    _this.$refs['emViewTitle'].$refs['emBreadCrumb'].goBack();
}

/**
 * task页面获取taskId
 * @param _this
 * @returns {string|*}
 */
function taskGetTaskId(_this) {
    if (_this.businessData && _this.businessData.hasOwnProperty('workflowTask') && _this.businessData.workflowTask && _this.businessData.workflowTask.hasOwnProperty('taskInstanceId')) {
        return _this.businessData.workflowTask.taskInstanceId
    } else {
        return ""
    }
}

export default {
    listMounted,
    listHandleApprove,
    taskMounted,
    taskIsEdit,
    taskHandleTaskCompleted,
    taskGetTaskId,
    getModifyFormName
};